<div class="browserContainer">
    <div>
      <span class="browserMessage">Current browser does not support ATAM functionality. Please access application in {{returnOfflineSupportedBrowserName()}} browser</span>
    </div>
</div>
